import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IOperatorPermisiuni, IOperatorUpdateFunctiePayload, IOperatorUpdatePermisiuniPayload } from './operatori-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class OperatoriProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDTOperatoriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.listDT;
    private listPermissionsOperatorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.listPermissions;
    private updatePermissionsOperatorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.updatePermissions;
    private updateFunctieOperatorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.updateFunctie;
    private getFunctieOperatorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteOperatori.getFunctie;

    private changeStatusResponsabilURL =
        this.basePath +
        environment.interop.monitoring.proiecte.setResponsabil;
    private changeStatusAgentURL =
        this.basePath +
        environment.interop.monitoring.proiecte.setAgent;

    constructor(private http: HttpClient) { }

    listDTOperatori() {
        return this.http.post(this.listDTOperatoriURL, {});
    }

    listPermisiuniOperator(id: number) {
        return this.http.get<{ errors: boolean; data: IOperatorPermisiuni; status_code: number }>(this.listPermissionsOperatorURL + id);
    }

    updatePermisiuniOperator(id: number, data: IOperatorUpdatePermisiuniPayload) {
        return this.http.post(this.updatePermissionsOperatorURL + id, data);
    }

    updateFunctieOperator(id: number, data: IOperatorUpdateFunctiePayload) {
        return this.http.put(this.updateFunctieOperatorURL + id, data);
    }

    getFunctieOperator(id: number) {
        return this.http.get(this.getFunctieOperatorURL + id);
    }

    changeStatusResponsabil(id_user: number) {
        return this.http.put(this.changeStatusResponsabilURL + id_user, {});
    }

    changeStatusAgent(id_user: number) {
        return this.http.put(this.changeStatusAgentURL + id_user, {});
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
